var React = require('react');

function UIGoinginplayGrey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.6 8.333a3.667 3.667 0 1 1-7.333 0 3.667 3.667 0 0 1 7.333 0zm-3.267 2.334V9H5.518C5.232 9 5 8.702 5 8.333c0-.368.232-.666.518-.666h2.815V6L11 8.333l-2.667 2.334z","fill":"#A3A1A7","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.889 1.333h4.222V2.36c.453.16.883.371 1.282.625l.83-.818 1.266 1.25-.738.728a6.333 6.333 0 1 1-9.502 0l-.74-.728 1.267-1.25.83.818c.4-.254.83-.464 1.283-.625V1.333zm2.044 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10z","fill":"#A3A1A7","key":1})]);
}

UIGoinginplayGrey.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = UIGoinginplayGrey;

UIGoinginplayGrey.default = UIGoinginplayGrey;
